import {BusinessModelVo} from '../../common/shared/api/nicolas/vo/enums/BusinessModelVo.enum';
import {Bm} from '../generated/types';

/**
 * 로직 참고 : https://podotree.atlassian.net/wiki/spaces/PSD/pages/2771092136?focusedCommentId=2819296272#comment-2819296272
 */
export function createBm({
  businessModel,
  isAllFree,
  isWaitfree,
}: {
  businessModel: BusinessModelVo;
  isAllFree: boolean;
  isWaitfree: boolean;
}): Bm {
  if (businessModel === BusinessModelVo.Web) {
    return Bm.FreePreview;
  } else {
    if (isAllFree) {
      return Bm.Free;
    } else if (isWaitfree) {
      return businessModel === BusinessModelVo.Mix
        ? Bm.MixedWaitfree
        : Bm.PayWaitfree;
    } else {
      return businessModel === BusinessModelVo.Mix ? Bm.MixedPay : Bm.Pay;
    }
  }
}
